<template>
    <div class="bzj_sm">
        <div class="tit">服务费说明</div>
        <p v-if="selection.is_partner_consignment">角色交易向卖家收取服务费：20~100元收取10元手续费，100元以上收取成交金额的10%。注：帐号交易服务费由卖家承担，卖家帐号出售成功以后直接从卖家货款中扣除交易费用。</p>
        <p v-else>角色交易向卖家收取每笔成交金额的{{ selection.rate }}%，最低为10元人民币。注：帐号交易服务费由卖家承担，卖家帐号出售成功以后直接从卖家货款中扣除交易费用。</p>
        <van-button round color="var(--theme)" class="know" @click="close">我已知晓</van-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        computed: {},
        created() {},
        mounted() {},
        methods: {
            close() {
                this.$emit('closeModal')
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .bzj_sm {
        padding: 2.4rem 2.4rem;

        .tit {
            font-size: 1.6rem;
            color: #606060;
            font-weight: 700;
            margin-bottom: 1.9rem;
            text-align: center;
        }

        p {
            font-size: 1.4rem;
            color: #555;
            line-height: 1.5;
            word-break: break-word;
        }

        table {
            margin: 1.2rem auto 1.4rem;
            border-collapse: collapse;
            border-color: #a4a4a4;
            width: 100%; 
            th,td {
                border: 1px solid #a4a4a4;
                text-align: center;
                height: 2.5rem;
                color: #000;
                font-size: 1.4rem;
                &:nth-child(1) {
                    width: 50%;
                }
                &:nth-child(2) {
                    width: 50%;
                }
            }
        }

        .know {
            width: 24rem;
            height: 3.2rem;
            display: block;
            margin: 1.9rem auto 0;
            font-size: 1.6rem;
        }
    }
</style>
